import * as React from 'react';

import * as styles from './ReviewLink.css';
import { EStarSize, EStarTheme, Star, getPrettyFloat } from '@cian/frontend-reviews-components';
import { Link } from '../Link';
import { IReviewStat } from '../../types/reviewStat';
import { UIHeading5, UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';

export interface IReviewLinkProps extends IReviewStat {
  newbuildingUrl: string;
  reviewLinkClick: () => void;
  hasLabels: boolean;
}

export function ReviewLink({
  reviewCountText,
  totalRate,
  newbuildingUrl,
  reviewLinkClick,
  hasLabels,
}: IReviewLinkProps) {
  const isLowRating = totalRate < 4;

  return (
    <Link
      data-testid="ReviewLink"
      className={styles['link']}
      url={`${newbuildingUrl}otzyvy/`}
      onClick={reviewLinkClick}
      target="blank"
    >
      <div className={clsx(styles['container'], hasLabels && styles['container--with-labels'])}>
        <div className={styles['star']}>
          <Star size={EStarSize.M} theme={isLowRating ? EStarTheme.NotFilled : EStarTheme.Filled} />
        </div>
        <UIHeading5 color={isLowRating ? 'text-secondary-default' : 'decorative-orange'} itemProp="ratingValue">
          {getPrettyFloat(totalRate)}{' '}
        </UIHeading5>
        <UIText2 color="text-secondary-default" itemProp="reviewCount">
          {' '}
          · {reviewCountText}
        </UIText2>
      </div>
    </Link>
  );
}
